import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-6 col-md-12 col-xs-12" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"textcard\"><h2> Quick recap;<br> The cool things you will get: </h2><br><ul><li>Unlimited bandwidth</li><li>Unlimited concurrent connections</li><li>Up to 50 000 HTTP/s and Socks4/5 datacenter proxies</li><li>Whitelist up to 3 IPs with the datacenter proxies (upgrades available)</li><li>Amazing shared datacenter proxies that always work</li><li>An easy to use dashboard to manage your proxies</li><li>Outstanding support that&#39;s ready to help you</li></ul></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6 col-md-12 col-xs-12 bigvp\"><div class=\"imagecard\"><img alt=\"good proxies\" src=\"https://cdn.proxyscrape.com/img/gp2.gif\"></div></div><div class=\"col-lg-6 col-md-12 col-xs-12 smallvp\"><div class=\"imagecard\"><img alt=\"good proxies\" src=\"https://cdn.proxyscrape.com/img/gp2.gif\"></div></div>", 2)

import CountryBox from '@/components/services/premium/shop-container/country-box.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(CountryBox)
    ]),
    _hoisted_3
  ], 64))
}
}

})